import {
  Button,
  createStyles,
  Grid,
  makeStyles,
  Theme,
} from "@material-ui/core";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import React from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import MoonLoader from "react-spinners/MoonLoader";
import Header from "../../common/Header";
import { useQueryParams } from "../../utils/queryParams";
import { setResults } from "../store/actions";
import { SelectedPlayers } from "../store/types";
import Heading from "./Heading";
import Rating from "./Rating";
import Table from "./Table";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      minHeight: "100vh",
      paddingTop: 24,
      backgroundColor: "#102341",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    cornerBackground: {
      height: "100%",
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 100,
      background: "linear-gradient(#015ACE, #102341)",
      clipPath: "polygon(0 0, 453px 0, 0% 430px)",
    },
    item: {
      zIndex: 100,
      margin: "24px 0",
      [theme.breakpoints.down("sm")]: {
        margin: "8px 0",
      },
    },
    button: {
      backgroundColor: "#015ACE50",
      padding: 16,
      fontSize: 24,
      fontWeight: 700,
      margin: "12px 0",
      color: theme.palette.common.white,
      borderRadius: 12,
      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      "&:hover": {
        backgroundColor: "#015ACE50",
      },
    },
    loader: {
      color: "white",
      marginTop: 8,
      fontFamily: "Roboto",
      "& span": {
        borderColor: "white !important",
      },
    },
  })
);

type PlayerCompareParams = {
  readonly league: string;
};

interface ReduxProps {
  readonly selectedPlayers: SelectedPlayers;
}

interface DispatchProps {
  readonly SetResults: (
    leagueCode: string,
    site: string,
    token: string,
    ids1: string[],
    ids2: string[]
  ) => void;
}

type Props = ReduxProps & DispatchProps;

const PlayerCompare = (props: Props) => {
  const { SetResults } = props;
  let { league } = useParams<PlayerCompareParams>();
  const [loading, SetLoading] = React.useState(true);
  let queryParams = useQueryParams();
  const site = queryParams.get("site") || "";
  const token = queryParams.get("token") || "";
  const side1 = queryParams.get("side1") || "";
  const side2 = queryParams.get("side2") || "";

  const classes = useStyles();

  React.useEffect(() => {
    const side1 = (queryParams.get("side1") || "").split("+");
    const side2 = (queryParams.get("side2") || "").split("+");

    SetResults(league, site, token, side1, side2);
  }, [league, SetResults, queryParams, site, token]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      SetLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={classes.root}>
      <Header />
      <div className={classes.cornerBackground}></div>
      {loading && (
        <Grid container alignItems="center" direction="column">
          <Grid className={classes.loader}>
            <MoonLoader />
          </Grid>
          <Grid className={classes.loader}>Comparing Players</Grid>
        </Grid>
      )}
      {!loading && (
        <Grid container>
          <Grid item xs={12} className={classes.item}>
            <Heading />
          </Grid>
          <Grid item xs={12} className={classes.item}>
            <Table />
          </Grid>
          <Grid item xs={12} className={classes.item}>
            <Rating />
          </Grid>
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            className={classes.item}
          >
            <Button
              startIcon={<SwapHorizIcon />}
              href={`/startsit/${league}?site=${site}&token=${token}&side1=${encodeURIComponent(
                side1
              )}&side2=${encodeURIComponent(side2)}`}
              className={classes.button}
              size="large"
            >
              Change Players
            </Button>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  const { selectedPlayers } = state.startSit;
  return {
    selectedPlayers,
  };
};

const mapDispatchToProps = {
  SetResults: setResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayerCompare);
